import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  CircularProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useMezzanine } from '../../context/MezzanineContext';
import { updateChannel } from '../../utilities/mezzanineApi';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    '& .MuiInputBase-root': { fontSize: '12px' },
    '& .MuiInputLabel-root': { fontSize: '12px' },
    '& .MuiMenuItem-root': { fontSize: '12px' },
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  infoLabel: {
    color: '#666',
    fontSize: '12px',
  },
  infoValue: {
    fontWeight: 'bold',
    fontSize: '12px',
  },
}));

const EditChannelDialog = ({ open, onClose, channel, onSuccess, onNotify }) => {
  const classes = useStyles();
  const { programGroups } = useMezzanine();
  const [selectedGroup, setSelectedGroup] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (channel && open) {
      setSelectedGroup(channel.group_name || '');
    }
  }, [channel, open]);

  const handleSave = async () => {
    if (!selectedGroup || selectedGroup === channel.group_name) {
      onClose();
      return;
    }

    setSaving(true);
    try {
      await updateChannel(channel.channel_id, selectedGroup);
      onNotify({ message: 'Channel updated successfully', severity: 'success' });
      onSuccess();
      onClose();
    } catch (err) {
      onNotify({ message: `Failed to update channel: ${err.message}`, severity: 'error' });
    } finally {
      setSaving(false);
    }
  };

  if (!channel) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle style={{ padding: '16px 20px', borderBottom: '1px solid #eee' }}>Edit Channel</DialogTitle>
      <DialogContent>
        <Box className={classes.form} mt={2}>
          <Box className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Channel</Typography>
            <Typography className={classes.infoValue}>{channel.channel_name}</Typography>
          </Box>
          <Box className={classes.infoRow}>
            <Typography className={classes.infoLabel}>Current Group</Typography>
            <Typography className={classes.infoValue}>{channel.group_name || 'None'}</Typography>
          </Box>

          <FormControl fullWidth variant="outlined" size="small" style={{ marginTop: '8px' }}>
            <InputLabel>Program Group</InputLabel>
            <Select
              value={selectedGroup}
              onChange={(e) => setSelectedGroup(e.target.value)}
              label="Program Group"
              disabled={saving}
              MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
            >
              {programGroups.map((group) => (
                <MenuItem key={group.group_name} value={group.group_name} style={{ fontSize: '12px' }}>
                  {group.group_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: '12px 20px' }}>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={saving || !selectedGroup || selectedGroup === channel.group_name}
          style={{ backgroundColor: (saving || !selectedGroup || selectedGroup === channel.group_name) ? '#ccc' : '#ff6f00', color: 'white' }}
        >
          {saving ? <CircularProgress size={20} style={{ color: 'white' }} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditChannelDialog;
